module.exports = __webpack_public_path__ + "static/media/Hangman6.e6a22e32.png";